import script from "./useStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./useStatistics.vue?vue&type=script&setup=true&lang=js"

import "./useStatistics.vue?vue&type=style&index=0&id=368030cc&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368030cc"]])

export default __exports__